import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { singleton } from "@/fp";
import { Env } from "@/common/models";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Overview",
    component: () =>
      /* webpackChunkName: "overview" */ import("@/views/overview/index.vue"),
  },
  {
    path: "/data-sources-management",
    name: "DataSourceManagement",
    component: () =>
      /* webpackChunkName: "DataSourceManagement" */ import(
        "@/views/customize/data-sources/index.vue"
      ),
  },
  {
    path: "/microsoft-labeling",
    name: "MIP",
    component: () =>
      /* webpackChunkName: "MIP" */ import("@/views/customize/mip/index.vue"),
  },
  {
    // Its own component so navigating between the two labeling entries mounts
    // a fresh screen; the screen itself is shared with Microsoft labeling.
    path: "/google-labeling",
    name: "GoogleLabeling",
    component: () =>
      /* webpackChunkName: "MIP" */ import(
        "@/views/customize/google-labeling/index.vue"
      ),
  },
  {
    path: "/information-customization",
    name: "InformationCustomization",
    component: () =>
      /* webpackChunkName: "InformationCustomization" */ import(
        "@/views/customize/information/index.vue"
      ),
  },
  {
    path: "/in-motion-customization",
    name: "InMotionCustomization",
    component: () =>
      /* webpackChunkName: "InMotionCustomization" */ import(
        "@/views/customize/in-motion/index.vue"
      ),
  },
  {
    path: "/trust-management",
    name: "TrustManagement",
    component: () =>
      /* webpackChunkName: "TrustManagement" */ import(
        "@/views/customize/in-motion/exposure-control/index.vue"
      ),
  },
  {
    path: "/playbooks",
    name: "Playbooks",
    component: () =>
      /* webpackChunkName: "Playbooks" */ import("@/views/playbooks/index.vue"),
  },
  {
    path: "/reports",
    name: "Reports",
    component: () =>
      /* webpackChunkName: "Reports" */ import("@/views/reports/index.vue"),
  },
  {
    path: "/report-generator",
    name: "ReportGenerator",
    component: () =>
      /* webpackChunkName: "ReportGenerator" */ import(
        "@/views/reports/generator/ReportGenerator.vue"
      ),
  },
  {
    path: "/entity-investigation",
    name: "Investigation-drilldown",
    beforeEnter: async (to, from, next) => {
      const { SharedState } = await import("@/common/state");
      if (SharedState.restrictions.is_restricted_app("entity_investigation")) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "Entity Investigation"
        );
        return;
      }
      next();
    },
    component: () =>
      import(
        /* webpackChunkName: "Investigation-drilldown" */ "@/views/entity-investigation/index.vue"
      ),
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "LoginView" */ "@/views/login/index.vue"),
  },
  {
    path: "/manual-ms-labeling",
    name: "ManualMipLabel",
    component: () =>
      import(
        /* webpackChunkName: "ManualMipLabel" */ "@/views/customize/mip/manual-label/index.vue"
      ),
  },
  {
    path: "/accounts",
    name: "Accounts",
    component: () =>
      import(/* webpackChunkName: "Accounts" */ "@/views/accounts/index.vue"),
  },
  {
    path: "/admins",
    name: "Admins",
    component: () =>
      import(/* webpackChunkName: "Admins" */ "@/views/admins/index.vue"),
  },

  // aliases
  {
    path: "**",
    name: "default",
    redirect: {
      name: "Overview",
    },
  },
];

const router = singleton<void | Env, VueRouter>((env: Env | void) => {
  if (!env) {
    throw Error("need to pass Env to init router singleton !!");
  }
  return new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: routes,
  });
});

export default router;
